export const i18n = {
    defaultLocale: 'en',
    locales: ['en', 'de', 'fr', 'es', 'uk', 'ru', 'it', 'pt'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export function isLocale(value: string): value is Locale {
    return i18n.locales.includes(value as Locale);
}

export function parseLocale(value: string | null | undefined): Locale | null {
    if (!value) return null;

    const trimmed = value.trim();
    if (!trimmed) return null;
    if (isLocale(trimmed)) return trimmed;

    const baseLocale = trimmed
        .replace(/_/g, "-")
        .split("-")[0]
        ?.toLowerCase();

    return baseLocale && isLocale(baseLocale) ? baseLocale : null;
}

export const localeLabels: Record<Locale, string> = {
    en: "English",
    de: "Deutsch",
    fr: "Francais",
    es: "Espanol",
    uk: "Ukrainska",
    ru: "Russkii",
    it: "Italiano",
    pt: "Portugues (Brasil)",
};

export type LocaleRecordInput<T> = Partial<Record<Locale, T>> & Record<typeof i18n.defaultLocale, T>;

export function defineLocaleRecord<T>(record: LocaleRecordInput<T>): Record<Locale, T> {
    const fallback = record[i18n.defaultLocale];
    return Object.fromEntries(
        i18n.locales.map((locale) => [locale, record[locale] ?? fallback])
    ) as Record<Locale, T>;
}
